import { Badge, Button, Icon } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";
import { TbFilter } from "react-icons/tb";

import { cn } from "@/lib/utils";
import { usePageFilters } from "@/providers/hooks/use-page-filters";

type PageFiltersToggleProps = {
    isOpen: boolean;
    onOpen: () => void;
};

export function PageFiltersToggle({ isOpen, onOpen }: PageFiltersToggleProps) {
    const { t } = useTranslation();
    const { filterSummary } = usePageFilters();

    return (
        <Button
            variant={isOpen ? "secondary" : "ghost"}
            size="sm"
            onClick={onOpen}
            className={cn("max-w-[min(100%,16rem)] shrink-0 gap-1.5 sm:max-w-none", isOpen && "bg-muted")}
            aria-pressed={isOpen}
            aria-label={t("show_filters")}
        >
            <Icon icon={TbFilter} className="shrink-0" />
            <span className="hidden shrink-0 sm:inline">{t("filters")}</span>
            {filterSummary.length > 0 ? (
                <span className="flex min-w-0 items-center gap-1">
                    {filterSummary.map((item) => (
                        <Badge
                            key={item.id}
                            variant="secondary"
                            size="sm"
                            className="max-w-[5.5rem] truncate font-normal sm:max-w-[8rem]"
                        >
                            {item.label}
                        </Badge>
                    ))}
                </span>
            ) : null}
        </Button>
    );
}
